import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesHeartOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.516 13.897c1.03-.26 2.16.003 3.086.811.933-.804 2.07-1.04 3.094-.766 1.28.344 2.304 1.482 2.304 2.99 0 1.361-.938 2.442-1.865 3.227-.959.812-2.156 1.513-3.073 2.063l-.462.278-.463-.278c-.916-.55-2.114-1.25-3.072-2.063-.927-.785-1.865-1.866-1.866-3.226 0-1.55 1.009-2.706 2.317-3.036m2.346 2.664c-.628-.897-1.388-1.05-1.906-.92-.533.136-.956.592-.956 1.292 0 .514.375 1.13 1.229 1.853.691.586 1.546 1.117 2.37 1.613.825-.496 1.68-1.027 2.372-1.613.854-.723 1.228-1.34 1.228-1.853 0-.628-.408-1.102-.969-1.252-.526-.141-1.274-.003-1.893.88l-.737 1.052z"
                    fill="currentColor"
                />
                <path
                    d="M12 2c9.625 0 11 1.25 11 10q0 .255-.003.5h-1.8q.002-.245.003-.5c0-2.172-.089-3.734-.328-4.889-.233-1.125-.577-1.7-.974-2.06-.416-.379-1.108-.72-2.422-.945C16.154 3.88 14.394 3.8 12 3.8s-4.154.08-5.476.306c-1.314.226-2.006.566-2.422.945-.397.36-.74.935-.974 2.06C2.888 8.266 2.8 9.828 2.8 12s.089 3.734.328 4.889c.233 1.125.577 1.7.974 2.06.416.379 1.108.72 2.422.945 1.322.226 3.082.306 5.476.306q.52 0 1-.007v1.801Q12.516 22 12 22C2.375 22 1 20.75 1 12S2.375 2 12 2"
                    fill="currentColor"
                />
                <path d="M12 12.9H6v-1.8h6z" fill="currentColor" />
                <path d="M18 8.9H6V7.1h12z" fill="currentColor" />
            </g>
        </svg>
    )
);
CardLinesHeartOutlinedSize24Glyph.displayName = 'CardLinesHeartOutlinedSize24Glyph';
